'use strict';

var Sugar = require('sugar-core');

require('./build/buildDateUnitMethodsCall');

module.exports = Sugar.Date.addMilliseconds;


// WEBPACK FOOTER //
// ./~/sugar-date/date/addMilliseconds.js